function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 16,
  height: 16,
  rx: 1,
  stroke: "#A0AFBE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.995a1 1 0 102 0H8zm2-5.99a1 1 0 00-2 0h2zM11.995 10a1 1 0 000-2v2zm-5.99-2a1 1 0 100 2V8zM10 11.995v-5.99H8v5.99h2zM11.995 8h-5.99v2h5.99V8z",
  fill: "#A0AFBE"
});
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgAdd;